<template>
  <div class="cause-contain">
    <div class="title">涉旅案件公示</div>
    <div class="content">
      <div class="list line_bottom" v-for="(item,index) in caseList" :key="index" @click="navTo(item.caseUrl,item.caseType)">
        <div class="edge">
          <div class="text">{{item.caseType}}</div>
          <div class="pic"><img src="../../../assets/appraise/ic_case.png"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'casePublicity',
        data () {
            return {}
        },
        props: {
            caseList: {
                type: Array
            }
        },
        methods: {
            navTo (url, name) {
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: url,
                        isFullScreen: 0,
                        setTitle: name,
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            }
        },
        mounted () {

        }
    }
</script>

<style lang="less" scoped>
  .cause-contain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
    }

    .content {
      margin-top: 12px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;

      .list {

        .edge {
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .text {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
          }

          .pic {
            width: 18px;
            height: 18px;
          }
        }
      }

      .line_bottom:last-child::after {
        border-bottom: 0;
      }
    }
  }
</style>
